import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950">
      <div className="mx-auto px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                黑
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                黑料<span className="text-accent-400">bu</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/70">
              黑料bu 是一个主题化的黑料合集整理入口，把黑料汇总与黑料大全按类别归好，方便集中查阅关键材料与背景脉络。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#collections"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-layout-grid-line w-4 h-4 flex items-center justify-center"></i>
                合集索引
              </a>
              <a
                href="#subscribe"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/25 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center"></i>
                订阅更新
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-background-50">
                  <a href="#top" className="cursor-pointer hover:text-accent-400">
                    {column.title}
                  </a>
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#collections"
                        className="whitespace-nowrap font-label text-sm text-background-100/70 transition-colors hover:text-accent-400"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-100/60">
            © 2026 黑料bu · 本站内容为整理演示，请以官方信息为准
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-background-100/60">
            <a href="#top" className="whitespace-nowrap hover:text-accent-400">
              免责声明
            </a>
            <a href="#top" className="whitespace-nowrap hover:text-accent-400">
              版权与纠错
            </a>
            <a href="#top" className="flex items-center gap-1 whitespace-nowrap hover:text-accent-400">
              <i className="ri-arrow-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}